import { DEFAULT_LANGUAGE, LOCALE_BY_LANGUAGE, isSupportedLanguage } from './config';
import i18n from './instance';
/**
 * Helpers de formatacao sensiveis ao idioma atual.
 *
 * O locale usado pelas APIs Intl e derivado do idioma corrente do i18next
 * (ex.: 'en' -> 'en-US', 'pt-BR' -> 'pt-BR'). Assim, datas e numeros seguem a
 * convencao do idioma selecionado sem que os componentes precisem conhecer
 * navigator.language nem o mapeamento de locales.
 */
/** Resolve o locale BCP-47 a partir do idioma atualmente ativo no i18next. */
export function getCurrentLocale() {
    var language = i18n.language || DEFAULT_LANGUAGE;
    if (isSupportedLanguage(language)) {
        return LOCALE_BY_LANGUAGE[language];
    }
    // i18next pode reportar variantes (ex.: 'en-US'); usa o prefixo base.
    var base = language.split('-')[0];
    if (isSupportedLanguage(base)) {
        return LOCALE_BY_LANGUAGE[base];
    }
    return LOCALE_BY_LANGUAGE[DEFAULT_LANGUAGE];
}
/**
 * Formata uma data (string, número ou Date) segundo o locale atual.
 * Retorna null quando o valor e ausente ou invalido.
 */
export function formatDate(value, options) {
    if (options === void 0) { options = { dateStyle: 'short', timeStyle: 'short' }; }
    if (value === undefined || value === null || value === '')
        return null;
    var date = value instanceof Date ? value : new Date(value);
    var time = date.getTime();
    // Checagem de "Invalid Date" sem depender de Number.isNaN (ES2015+):
    // uma data invalida retorna NaN, e NaN !== NaN.
    if (time !== time)
        return null;
    return new Intl.DateTimeFormat(getCurrentLocale(), options).format(date);
}
/** Formata um numero segundo o locale atual. */
export function formatNumber(value, options) {
    return new Intl.NumberFormat(getCurrentLocale(), options).format(value);
}
